<template>
  <div>
    <v-layout v-show="searchView">
      <v-autocomplete
        v-if="!currentPosition"
        :label="label"
        :loading="loading"
        :items="locations"
        :search-input.sync="search"
        item-text="description"
        :filter="filterFunc"
        :placeholder="showPlaceHolder ? 'Search, or click on the map...' : null"
        return-object
        hide-no-data
        clearable
        append-icon=""
        v-model="selected"
        @input="valueChange">
        <v-icon v-if="currentLocationBtn" slot="append-outer"
                @click="setCurrentPosition">gps_fixed</v-icon>

        <v-icon slot="append-outer" v-if="enableCoordinates"
                @click="searchView = false">place</v-icon>
      </v-autocomplete>

      <v-text-field
        v-if="currentPosition"
        :label="label"
        readonly
        append-icon=""
        v-model="currentPositionLabel">
        <v-icon slot="append-outer" @click="resetCurrentPosition">clear</v-icon>
      </v-text-field>
    </v-layout>
    <v-layout v-if="enableCoordinates"
              v-show="!searchView">
      <v-flex>
        <v-text-field
          @input="searchLocation"
          type="number"
          label="Latitude"
          v-model.number="lat">
        </v-text-field>
      </v-flex>
      <v-flex class="ml-3">
        <v-text-field
          @input="searchLocation"
          type="number"
          label="Longitude"
          v-model.number="lng">
          <v-icon slot="append-outer"
                  @click="searchView = true">search</v-icon>
        </v-text-field>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import API from '@/api';
import { mapGetters } from 'vuex';
import { get } from 'lodash';

const CURRENT_LOCATION = 'Current Location';

export default {
  name: 'AddressSearch',
  props: {
    value: {
      type: Object,
    },
    label: {
      type: String,
      default: 'Address',
    },
    currentLocationBtn: {
      type: Boolean,
      default: false,
    },
    showPlaceHolder: {
      type: Boolean,
      default: false,
    },
    enableCoordinates: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchView: true,
      active: null,
      loading: false,
      search: null,
      selected: null,
      currentPosition: false,
      currentPositionLabel: CURRENT_LOCATION,
      locations: [],
      lat: null,
      lng: null,
    };
  },
  computed: {
    ...mapGetters('maps', [
      'userLocation',
    ]),
  },
  watch: {
    search(val) {
      if (val && (!this.selected || (val !== this.selected.description))) {
        this.querySelections(val);
      }
    },
    value(newVal) {
      if (!newVal) {
        this.selected = null;
      } else if (get(this.selected, 'place_id', null) !== get(newVal, 'place_id', null)) {
        this.updateInput();
      }
    },
  },
  mounted() {
    this.updateInput();
  },
  methods: {
    updateInput() {
      if (this.value && this.value.place_id) {
        if (this.value.formatted_address) {
          this.value.description = this.value.formatted_address;
        }

        if (!this.value.description) {
          API.map.searchCode({ placeId: this.value.place_id }).then((results) => {
            if (results && results.length) {
              this.selected = results[0];
              this.search = results[0].formatted_address;
            }
          });
        } else {
          this.locations = [this.value];
          this.selected = this.value;
          this.search = this.value.description;
        }
      }

      if (get(this.value, 'geometry.location', null)) {
        this.lng = this.value.geometry.location.lng();
        this.lat = this.value.geometry.location.lat();
      }
    },
    searchLocation() {
      if (this.lat && this.lng) {
        API.map.searchCode({ location: { lat: this.lat, lng: this.lng } }).then((results) => {
          if (results && results.length) {
            this.$emit('input', { ...results[0], description: results[0].formatted_address });
          }
        });
      }
    },
    resetCurrentPosition() {
      this.currentPosition = false;
      this.$emit('changeLocation', null);
    },
    setCurrentPosition() {
      this.$store.dispatch('maps/getUserPosition').then(() => {
        this.currentPosition = true;
        this.$emit('changeLocation', { lng: this.userLocation.longitude, lat: this.userLocation.latitude });
      });
    },
    valueChange(val) {
      this.$emit('changePlaceId', get(val, 'place_id', null));
      this.$emit('input', val);
      if (val) {
        API.map.searchCode({ placeId: val.place_id }).then((results) => {
          if (results.length) {
            this.lng = results[0].geometry.location.lng();
            this.lat = results[0].geometry.location.lat();
            this.$emit('changeLocation', { lng: this.lng, lat: this.lat });
          }
        });
      } else {
        this.$emit('changeLocation', null);
      }
    },
    filterFunc() {
      return true;
    },
    querySelections(val) {
      this.loading = true;
      API.map.search(val).then((searchResults) => {
        this.locations = searchResults || [];
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/components/AddressSearch.vue